/**
 * Decorative hand-drawn ivy vine SVG that can wrap a card corner.
 * Use absolute positioning + rotation classes to place it.
 */
export default function IvyVine({ className = "", flip = false }) {
  return (
    <svg
      viewBox="0 0 220 180"
      className={className}
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      aria-hidden="true"
      fill="none"
    >
      <path
        d="M10 10 C 40 40, 30 70, 70 80 S 130 100, 150 140"
        stroke="#3A5439"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M70 80 C 60 55, 90 50, 95 70 C 100 88, 78 92, 70 80 Z"
        fill="#3A5439"
        opacity="0.85"
      />
      <path
        d="M120 110 C 108 88, 138 82, 142 102 C 146 122, 126 124, 120 110 Z"
        fill="#3A5439"
        opacity="0.85"
      />
      <path
        d="M40 38 C 30 22, 56 18, 60 32 C 64 48, 46 50, 40 38 Z"
        fill="#3A5439"
        opacity="0.85"
      />
      <circle cx="155" cy="148" r="2.5" fill="#D4AF37" />
      <circle cx="60" cy="36" r="1.6" fill="#D4AF37" />
      <circle cx="100" cy="75" r="1.6" fill="#D4AF37" />
    </svg>
  );
}
